import type { WorkflowRequest } from '../model';
import { isManagedPersonnelRequest, type WorkerPersonnelRequestTarget } from '../../staffing/public';

export function workflowPersonnelRequestTarget(request: WorkflowRequest | undefined): WorkerPersonnelRequestTarget | undefined {
  if (request?.target?.resourceType !== 'WORKER_LIFECYCLE_EVENT') return undefined;
  const values = request.values ?? {};
  const target = { id: request.target.resourceId, processType: typeof values.processType === 'string' ? values.processType : '', status: request.status, correctionOf: values.correctionOf, transitionKind: values.transitionKind };
  return isManagedPersonnelRequest(target) ? target : undefined;
}
